<template>
  <div>
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; line-height: 1.5"
    >
      <tbody>
        <tr>
          <td style="vertical-align: top;width: 120px;" />
          <td style="vertical-align: top;">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              role="presentation"
              style="font-size: 0; margin-left: 8px;"
            >
              <tbody>
                <!-- Name and job fields -->
                <tr style="padding-bottom: 10px; display:block;">
                  <td>
                    <span
                      :style="[fontBase, {
                        fontSize: `${options.font.size + 3}px`,
                        color: '#666',
                        fontWeight: 700
                      }]"
                    >{{ mainFields[0].value }}</span>
                    <span
                      :style="[fontBase, {
                        fontSize: `${options.font.size + 1}px`,
                        color: '#666',
                      }]"
                    >&nbsp;—&nbsp;</span>
                    <span
                      :style="[fontBase, {
                        fontSize: `${options.font.size + 1}px`,
                        color: '#666',
                      }]"
                    >{{ mainFields[1].value }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <!-- Avatar column -->
        <tr>
          <td
            style="vertical-align: top; border-right: 2px solid"
            :style="{
              borderRightColor: options.color.ibisStylesMain
            }"
          >
            <avatar
              src="https://treatec.ams3.digitaloceanspaces.com/ibis/logo_ibis_styles.jpg"
              :show-avatar="showAvatar"
              :size="options.avatar.size"
              :roundness="options.avatar.roundness"
            />
          </td>
          <!-- Info column -->
          <td style="vertical-align: middle;">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              role="presentation"
              style="font-size: 0; margin-left: 8px;"
            >
              <tbody>
                <!-- Other fields -->
                <tr>
                  <td>
                    <table
                      cellspacing="0"
                      cellpadding="0"
                      border="0"
                      role="presentation"
                      style="font-size: 0;"
                    >
                      <template v-for="(item) in otherFields">
                        <tr
                          v-if="item.value"
                          :key="item.key"
                          :style="{
                            paddingBottom: item.key === 'phone' || item.key === 'fax' || item.key === 'email' ? '4px' : '0px',
                            display: item.key === 'phone' || item.key === 'fax' ? 'inline-block' : 'block',
                            float: item.key === 'phone' || item.key === 'fax' ? 'left' : 'none',
                            clear: item.key === 'phone' || item.key === 'fax' ? 'none' : 'both',
                          }"
                        >
                          <td>
                            <a
                              v-if="item.type === 'link'"
                              :href="formatLink(item.value)"
                              style="text-decoration: none; color: inherit;"
                              :style="fontBase"
                            >{{ item.value }}</a>
                            <a
                              v-if="item.type === 'email'"
                              :href="`mailto:${item.value}`"
                              style="text-decoration: none; color: inherit;"
                              :style="[fontBase, {
                                fontSize: `${options.font.size + 1}px`,
                                lineHeight: `${14}px`,
                                color: options.color.ibisStylesMain
                              }]"
                            >{{ item.value }}</a>
                            <span
                              v-if="item.type === 'text' && item.key != 'phone' && item.key != 'fax' && item.key.indexOf('operating') === -1"
                              :style="[fontBase, {
                                fontSize: item.key === 'company' ? `${options.font.size + 3}px` : `${options.font.size}px`,
                                color: item.key === 'company' ? options.color.ibisStylesMain : '#666',
                                fontWeight: item.key === 'company' ? 700 : 400,
                                lineHeight: `${14}px`
                              }]"
                            >{{ item.value }}</span>
                            <span
                              v-if="item.type === 'text' && item.key === 'phone'"
                              :style="[fontBase, {lineHeight: `${14}px`, color: '#666', fontSize: `${options.font.size}px`}]"
                            >T {{ item.value }}</span>
                            <span
                              v-if="item.type === 'text' && item.key === 'fax'"
                              :style="[fontBase, {lineHeight: `${14}px`, color: '#666', fontSize: `${options.font.size}px`}]"
                            >&nbsp;•&nbsp;F {{ item.value }}</span>
                            <span
                              v-if="item.type === 'text' && item.key === 'operatingCompanyName'"
                              :style="[fontBase, {lineHeight: `${10}px`, color: '#666', fontSize: `${options.font.size - 1}px`, fontWeight: 700}]"
                            >{{ item.value }}</span>
                            <span
                              v-if="item.type === 'text' && item.key.indexOf('operating') > -1 && item.key != 'operatingCompanyName'"
                              :style="[fontBase, {lineHeight: `${10}px`, color: '#666', fontSize: `${options.font.size - 1}px`}]"
                            >{{ item.value }}</span>
                          </td>
                        </tr>
                      </template>

                      <!-- Homepage Links -->
                      <tr style="display: block;padding:2px 0 0;">
                        <td>
                          <a
                            target="_blank"
                            :href="formatLink('ibis.com')"
                            :style="[fontBase, { fontSize: `${options.font.size + 1}px`}]"
                          >ibis.com</a>
                          <span
                            :style="[fontBase, { fontSize: `${options.font.size + 1}px`}]"
                          >&nbsp;•&nbsp;</span>
                          <a
                            target="_blank"
                            :href="formatLink('accorhotels.com')"
                            :style="[fontBase, { fontSize: `${options.font.size + 1}px`}]"
                          >accorhotels.com</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Addons -->
    <table
      v-if="socials.installed.length"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; line-height: 1.5"
    >
      <tbody>
        <td style="vertical-align: top;width: 130px;" />
        <td style="vertical-align: top;width: 2px;" />
        <td style="vertical-align: top;">
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            role="presentation"
            style="font-size: 0; margin-left: 6px;"
          >
            <tbody>
              <tr>
                <!-- :style="{
                            backgroundColor: options.color.ibisStylesMain,
                                }"-->
                <td
                  v-for="item in socials.installed"
                  :key="item.name"
                  align="center"
                  style="width: 20px; height: 20px;padding: 10px 2px;"
                >
                  <!-- :src="`${s3url}/icons/${item.icon}.png`" -->
                  <a
                    :href="formatLink(item.link)"
                    target="_blank"
                  >
                    <img
                      width="20px"
                      height="20px"
                      :src="`https://ams3.digitaloceanspaces.com/treatec/ibis/${item.icon}.png`"
                      :alt="`social-icon-${item.icon}`"
                      style="display: table-cell; vertical-align: middle;padding-right:2px;"
                    >
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tbody>
    </table>

    <!-- Addons -->
    <table
      v-if="isAdded('mobileApp')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="margin-top: 10px; font-size: 0;"
    >
      <tbody>
        <tr>
          <td v-if="addons.mobileApp.appStore.link">
            <a :href="addons.mobileApp.appStore.link">
              <img
                :src="addons.mobileApp.appStore.img"
                style="height:35px; margin-right: 5px;"
                alt="app store badge"
              >
            </a>
          </td>
          <td v-if="addons.mobileApp.googlePlay.link">
            <a :href="addons.mobileApp.googlePlay.link">
              <img
                :src="addons.mobileApp.googlePlay.img"
                style="height:35px;"
                alt="google play badge"
              >
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="isAdded('disclaimer')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; color: #888; margin-top: 10px;"
    >
      <tbody>
        <tr>
          <td>
            <pre>
              <span :style="fontBase">{{ addons.disclaimer }}</span>
            </pre>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="isAdded('banner')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; margin-top: 10px;"
    >
      <tbody>
        <tr>
          <td>
            <img
              src="https://ams3.digitaloceanspaces.com/treatec/ibis/banner_ibis_business_DE.jpg"
              alt="banner"
              style="width: 100%"
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EmailTemplate from './emailTemplate'
import Avatar from './components/Avatar'
import { fieldReorderByKey } from '@/util/helpers'

export default {
  name: 'SignaturTemplate1',

  components: {
    Avatar
  },

  extends: EmailTemplate,

  data () {
    return {
      filterFields: ['fullName', 'jobTitle']
    }
  },

  computed: {
    otherFields () {
      if (this.isEmpty) {
        /* eslint-disable no-undef */
        return fields.basicPlaceholder.filter(
          item => !this.filterFields.includes(item.key)
        )
      }
      let arr = this.basic.fields.filter(
        item => !this.filterFields.includes(item.key) && item.value
      )
      // reorder fields
      fieldReorderByKey(arr, 'address', 2)
      fieldReorderByKey(arr, 'phone', 3)
      fieldReorderByKey(arr, 'fax', 4)
      fieldReorderByKey(arr, 'email', 5)
      fieldReorderByKey(arr, 'operatingCompanyName', 6)
      fieldReorderByKey(arr, 'operatingCompanyInfos', 7)
      fieldReorderByKey(arr, 'operatingCompanyDirectors', 8)
      fieldReorderByKey(arr, 'operatingCompanyVat', 9)

      return arr
    },
    isCustomFieldsExist () {
      return this.otherFields.some(i => i.custom)
    }
  }
}
</script>
